import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable.js';
import useObtenerMenuPermissions from '../../Components/Hooks/useObtenerMenuPermissions.js';
import useCreateMenuPermission from '../../Components/Hooks/useCreateMenuPermission.js';
import useUpdateMenuPermission from '../../Components/Hooks/useUpdateMenuPermission.js';
import useDeleteMenuPermission from '../../Components/Hooks/useDeleteMenuPermission.js';
import ModalCrearMenuPermission from '../../Components/modals/ModalCrearMenuPermission.js';
import ModalModificarMenuPermission from '../../Components/modals/ModalModificarMenuPermission.js';
import ModalLeerMenuPermission from '../../Components/modals/ModalLeerMenuPermission.js';

const MenuPermissions = () => {

    const [selectedMenuPermission, setSelectedMenuPermission] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const { menuPermissions, loading, error } = useObtenerMenuPermissions(refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const { createMenuPermission, loading: createLoading, error: createError } = useCreateMenuPermission();
    const { updateMenuPermission, loading: updateLoading, error: updateError } = useUpdateMenuPermission();
    const { deleteMenuPermission, loading: deleteLoading, error: deleteError } = useDeleteMenuPermission();

    useEffect(() => {
        document.title = "Permisos de Menú | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "ID de Menú",
                accessorKey: "menu_id",
                enableColumnFilter: false,
            },
            {
                header: "Rol",
                accessorKey: "role",
                enableColumnFilter: false,
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        setSelectedMenuPermission(cellInfo.rowData);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Permisos de Menú</h5>
                                    <div className="d-flex align-items-center">
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Button color="info" className="me-2" onClick={() => { if (selectedMenuPermission) setModalLeerOpen(true); }} disabled={!selectedMenuPermission}>
                                            <i className="ri-eye-line me-1"></i>Ver
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedMenuPermission) setModalModificarOpen(true) }} disabled={!selectedMenuPermission || updateLoading}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="danger" className="me-2" onClick={async () => {
                                            if (selectedMenuPermission && window.confirm('¿Está seguro que desea eliminar este permiso de menú? Esta acción no se puede deshacer.')) {
                                                const result = await deleteMenuPermission(selectedMenuPermission.menu_id, selectedMenuPermission.role);
                                                if (result) {
                                                    alert('Permiso de menú eliminado');
                                                    setRefresh(prev => prev + 1);
                                                } else {
                                                    alert('Error: No se pudo eliminar');
                                                }
                                            }
                                        }} disabled={!selectedMenuPermission || deleteLoading}>
                                            <i className="ri-delete-bin-line me-1"></i>Eliminar
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={menuPermissions?.records || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearMenuPermission
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createMenuPermission(formData);
                    if (result) {
                        alert('Permiso de menú creado exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al crear permiso de menú: ' + createError);
                    }
                }}
            />
            <ModalModificarMenuPermission
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                selectedMenuPermission={selectedMenuPermission}
                onSave={async (formData) => {
                    const result = await updateMenuPermission(selectedMenuPermission.menu_id, selectedMenuPermission.role, formData);
                    if (result) {
                        alert('Permiso de menú actualizado exitosamente');
                        setModalModificarOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al actualizar permiso de menú: ' + updateError);
                    }
                }}
            />
            <ModalLeerMenuPermission
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedMenuPermission={selectedMenuPermission}
            />
        </React.Fragment>
    )
}

export default MenuPermissions;